<script>
   /*************************************************************
   * Point series for any set                                   *
   **************************************************************/

   import { Points, Lines } from 'svelte-plots-basic/2d';
   import { ps } from './settings.js';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let type = 'p';  // plot type
   export let values;      // JSON with x and y-values
</script>

{#if values }

   {#if type == "l" || type == "b"}
   <Lines xValues={values.x} yValues={values.y} lineWidth={ps[values.id].lineWidth} lineColor={ps[values.id].lineColor} />
   {/if}

   {#if type == "p" || type == "b"}
   <Points xValues={values.x} yValues={values.y} marker={ps[values.id].marker} borderWidth={ps[values.id].borderWidth}
      faceColor={ps[values.id].faceColor} borderColor={ps[values.id].borderColor}/>
   {/if}

{/if}

